import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseDateStack from '../../DateStack'

export const Link = styled.span`
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: ${color.AQUAMARINE};
  cursor: pointer;

  &:hover {
    color: ${color.SCOOTER};
  }
`
export const ClickableLink = styled.span`
  cursor: pointer;
`

export const Info = styled.div`
  color: ${color.GREY};
  font-size: 0.75rem;
  line-height: 1.25rem;
`

export const CheckInfoContainer = styled.div``

export const ListBillingItem = styled.div`
  padding: 0.625rem 0;
  display: flex;
  justify-content: space-between;
  line-height: 1.5625rem;
  font-size: 1.125rem;
  border-bottom: solid 1px ${color.GREY};
  transition: background 200ms;
  align-content: center;
  align-items: center;
`

export const DateStack = styled(BaseDateStack)`
  margin-right: 0.625rem;

  ${p =>
    p.expanded &&
    `
    transition: all 0.01s linear;
    margin-bottom: 1.875rem;
  `}
`

export const Transactions = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TransactionItem = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  color: ${color.MORTAR};
  font-size: 1.125rem;
  line-height: 1.5625rem;
`

export const Value = styled.div`
  color: ${color.MORTAR};

  ${p =>
    p.expanded &&
    `
    text-align: right;
  `}

  ${p =>
    p.negative &&
    `
    color: ${color.WATERMELON};
  `}
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`
